module.exports = __webpack_public_path__ + "img/thumb_compressed.d2da021b.svg";